<script>
import AkLabel from '@components/v2/general/AkLabel';

export default {
  components: {AkLabel},
  inject: {pSubmitted: {default: null}, pDisabled: {default: null}},
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    validator: {
      type: Object,
      required: false,
      default: undefined,
    },
    submitted: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    insideDialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    getPlaceholder() {
      return this.placeholder ? this.placeholder : this.label;
    },
    alreadySubmitted() {
      if (this.submitted !== undefined) return this.submitted;
      if (this.pSubmitted !== undefined) return this.pSubmitted;
      return false;
    },
    isDisabled() {
      if (this.disabled !== undefined) return this.disabled;
      if (this.pDisabled !== undefined) return this.pDisabled;
      return false;
    },
    isInvalid() {
      return this.validator !== undefined && this.validator.$invalid;
    },
    isRequired() {
      return this.validator !== undefined && this.validator.required !== undefined;
    },
    isValidatorRequired() {
      return (
        this.validator !== undefined &&
        this.validator.required !== undefined &&
        this.validator.required.$invalid &&
        this.alreadySubmitted
      );
    },
  },
  methods: {
    onOpen() {
      if (this.insideDialog) this.$refs.akColorPicker.className += ' min-h-[380px]';
    },
    onClose() {
      if (this.insideDialog)
        this.$refs.akColorPicker.className = this.$refs.akColorPicker.className.replace(' min-h-[380px]', '');
    },
  },
};
</script>

<template>
  <div ref="akColorPicker" :class="className" class="w-full input-layout form-control">
    <AkLabel :required="isRequired">
      {{ label }}
    </AkLabel>
    <VSwatches
      v-model="currentValue"
      :disabled="isDisabled"
      :inline="inline"
      :class="{disabled: isDisabled, 'p-invalid': isInvalid && alreadySubmitted}"
      class="w-full"
      trigger-style="{ width: '100%'}"
      fallback-input-type="color"
      show-fallback
      @open="this.onOpen"
      @close="this.onClose" />
    <small v-if="isValidatorRequired" class="p-error">{{ $t('field_required', [label]) }}</small>
  </div>
</template>
